<app-page-title
  [breadcrumbItems]="breadCrumbItems"
  [title]="('INVOICES.INVOICE' | translate) + ' ' + (data()?.invoiceNumber ?? '')"
  class="print-breadcrumb"
/>

@if (isLoading()) {
  <div class="card" [style.height.px]="400">
    <spinner/>
  </div>
} @else {
  <div class="row mt-4 justify-content-center print-body">
    <div class="col-xxl-9">
      <invoice-card [invoice]="data()"/>
    </div>
  </div>
}
